import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataAccumulativePage } from '../../../../redux/actions/pages/trans/accumulative';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, ACCUMULATIVE_TRANS_GET, PRINT_TRANS_EXTERNAL_LINK, EXCEL_EXPORT_EXTERNAL_LINK, PDF_EXPORT_EXTERNAL_LINK } from '../../../../apis';
import axios from "axios";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataModalTransDetails } from '../../../../redux/actions/partials/modals/modalTransDetails';


const Accumulative = () => {

	const dispatch = useDispatch();


	const { token, profile } = useSelector(state => state.login);
    const { totalSell, shopShare, title, fromDate, toDate, showSellBox } = useSelector(state => state.accumulative);



    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);


    const callApiGetAccumulative = (event) => {
        if(event !== undefined)
            event.preventDefault();
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'get',
            url: BASE_SITE + ACCUMULATIVE_TRANS_GET,
            params: {from_date: fromDate, to_date: toDate},
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                    break;
                case 'ok':
                    dispatch(handleChangeDataAccumulativePage('totalSell', response.data.total_sell));
                    dispatch(handleChangeDataAccumulativePage('shopShare', response.data.shop_share));
                    dispatch(handleChangeDataAccumulativePage('title', response.data.title));
                    dispatch(handleChangeDataAccumulativePage('showSellBox', true));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            dispatch(handleSetBackdropLoading(false));
        });
    };



    const DatePickerInput = (props) => {
        return <input className="popo" {...props} />;
    };

    const changeFromDate = (unix, formatted) => {
       dispatch(handleChangeDataAccumulativePage('fromDate', formatted)); 
    };

    const changeToDate = (unix, formatted) => {
       dispatch(handleChangeDataAccumulativePage('toDate', formatted)); 
    };


    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row className="row">
                        <div className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">گزارش مجموع خرید  {title}</h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className="icon-minus4"></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                            
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body collapse in">

                                    <div className="card-block" id="div-search" >
                                        <form>
                                        <div className="form-body" style={{overflow: 'unset !important'}} >
                                            <Row className="row">
                                                <div style={{display: 'flex', justifyContent: 'flex-start'}} >
                                                    <div style={{display: 'flex', justifyContent: 'space-between'}} >

                                                        <DatePicker
                                                                icon="fa fa-calendar"
                                                                inputComponent={DatePickerInput}
                                                                placeholder="از تاریخ"
                                                                format="jYYYY/jMM/jDD"
                                                                id="datePicker"
                                                                preSelected={""}
                                                                value={fromDate}
                                                                onChange={changeFromDate}
                                                                cancelOnBackgroundClick={true}
                                                                containerClass={"form-group col-xs-6 mb-0 date-picker pos-initial"}
                                                            />

                                                        <DatePicker
                                                                icon="fa fa-calendar"
                                                                inputComponent={DatePickerInput}
                                                                placeholder="تا تاریخ"
                                                                format="jYYYY/jMM/jDD"
                                                                id="datePicker"
                                                                preSelected={""}
                                                                value={toDate}
                                                                onChange={changeToDate}
                                                                cancelOnBackgroundClick={true}
                                                                containerClass={"form-group col-xs-6 mb-0 date-picker pos-initial"}
                                                            />

                                                    

                                                        <button type="submit" className="btn btn-success ml-3" name="search_btn" value="search"
                                                                style={{marginRight: '15px'}}
                                                                onClick={callApiGetAccumulative} >
                                                            <i className="icon-search"></i> جستجو 
                                                        </button>

                                                    </div>
                                                </div>
                                            </Row>

                                            <Row className="row mt-3" style={{paddingLeft: '0.99rem', paddingLeft: '0.99rem'}} >
                                                
                                                { showSellBox ?
                                                <div className="alert alert-info" role="alert">
                                                    <span>مجموع فروش  <span className="mx-1" style={{fontSize: 'large', fontSize: 'large', fontWeight: 'bold'}} >{parseInt(totalSell).toLocaleString()}</span> ریال</span>
                                                    <br />
                                                    <span>سهم فروشگاه <span className="mx-1" style={{fontSize: 'large', fontSize: 'large', fontWeight: 'bold'}} >{parseInt(shopShare).toLocaleString()}</span> ریال</span>
                                                </div>
                                                :''}
                                            </Row>
                                        </div>
                                        </form>
                                    </div>

                                    


                                    
                                </div>
                            </div>
                        </div>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default Accumulative;